import { render, staticRenderFns } from "./basicDataList.vue?vue&type=template&id=51805e16&scoped=true&"
import script from "./basicDataList.vue?vue&type=script&lang=js&"
export * from "./basicDataList.vue?vue&type=script&lang=js&"
import style0 from "./basicDataList.vue?vue&type=style&index=0&id=51805e16&prod&scoped=true&lang=css&"
import style1 from "./basicDataList.vue?vue&type=style&index=1&id=51805e16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51805e16",
  null
  
)

export default component.exports